import {FirebaseOptions} from "@firebase/app";

export const firebaseConfig: FirebaseOptions = {
    appId: process.env.REACT_APP_FB_APP_ID,
    apiKey: process.env.REACT_APP_FB_API_KEY,
    authDomain: process.env.REACT_APP_FB_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FB_PROJECT_ID,
}